import { render, staticRenderFns } from "./problemList.vue?vue&type=template&id=b1403a12&scoped=true&"
import script from "./problemList.vue?vue&type=script&lang=js&"
export * from "./problemList.vue?vue&type=script&lang=js&"
import style0 from "./problemList.vue?vue&type=style&index=0&id=b1403a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1403a12",
  null
  
)

export default component.exports